module.exports = __webpack_public_path__ + "img/journal_add_photo_alternate.07325560.svg";